module.exports = __webpack_public_path__ + "img/ben-solution-hero.dc94e51e.svg";